<template>
  <el-dialog :append-to-body="true" id="phone-verification-layer" title="短信校验" :visible.sync="dialogVisible" width="506px" :center="true">
    <div class="verification-tip">用章申请授权需要通过短信校验才可完成</div>
    <div class="verification-phone">您绑定的手机号   <span>{{phone}}</span></div>
    <el-form @submit.native.prevent :model="verificationForm" :rules="verificationRules" ref="verificationForm" label-width="0" class="verification-Form">
      <el-form-item prop="smgcode">
        <el-input placeholder="输入验证码" maxlength="6" v-model="verificationForm.smgcode"></el-input>
        <div class="code-btn">
          <el-button type="primary" :disabled="!sendAuthCode" @click="getMsgAuthCode" v-show="sendAuthCode">获取验证码</el-button>
          <el-button type="primary" v-show="!sendAuthCode"> {{auth_time}}秒</el-button>
        </div>
      </el-form-item>
    </el-form>

    <div class="dialog-btns">
      <el-button type="primary" @click="submitHandle" class="btn-ok">确认</el-button>
      <el-button type="info" @click="cancel" class="btn-cancel">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getsmsCodeApi } from '@/api/common'
import { mapState } from 'vuex'
import { addAuthorizeApi, agreeAuthorizeApi } from '@/api/space/authorize'
export default {
  props: ['authorizeData'],
  data() {
    return {
      dialogVisible: false,
      verificationForm: {
        smgcode: ''
      },
      verificationRules: {
        smgcode: [
          { required: true, message: '请输入验证码！', trigger: 'blur' }
        ]
      },
      auth_time: 0,
      sendAuthCode: true
    }
  },
  computed: {
    phone() {
      var str1 = '';
      if (this.userInfo.phone) {
        str1 = this.userInfo.phone.replace(/(\d{3})(\d+)(\d{4})/,function(x,y,z,p){
          var i="";
          while(i.length<z.length){i+="*"}
          return y+i+p
        })

        return str1
      }
      
    },
    ...mapState([
      'userInfo',
      'currentSpace'
    ])
  },
  methods: {
    getMsgAuthCode() {
      getsmsCodeApi({
        phone: this.userInfo.phone,
        type: 'seal'
      }).then(res => {
        if (res.code !== "0") {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          this.$message({
            message: '短信发送成功',
            type: 'success'
          });
          // 倒计时
          this.sendAuthCode = false;
          this.auth_time = 60;
          var auth_timetimer = setInterval(() => {
            this.auth_time--;
            if (this.auth_time <= 0) {
              this.sendAuthCode = true;
              clearInterval(auth_timetimer);
            }
          }, 1000);
        }
      }).catch(err => {
        console.log(err)
        // this.$message.error('服务器错误！');
      })
    },
    submitHandle() {
      this.$refs['verificationForm'].validate((valid) => {
        if (valid) {
          
          if (this.authorizeData.messageId) {  // 同意授权
            this.agreeAuthorizeHandle()
          } else {  // 添加授权
            this.addAuthorizeHandle()
          }
          
        }
      })
    },
    addAuthorizeHandle() {
      addAuthorizeApi({ 
        userId: this.authorizeData.userId,
        code: this.verificationForm.smgcode,
        sealId: this.authorizeData.sealId,
        companyId: this.currentSpace.companyId || ''
      }).then(res => {
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          this.$message({
            showClose: true,
            message: '授权成功！',
            type: 'success'
          });

          this.cancel()
          this.$parent.init()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    agreeAuthorizeHandle() {
      agreeAuthorizeApi({
        messageId: this.authorizeData.messageId,
        code: this.verificationForm.smgcode
      }).then(res => {
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          this.$message({
            showClose: true,
            message: '授权成功，申请人可使用该章！',
            type: 'success'
          });

          this.cancel()
          this.$parent.init()
        }
      })
    },
    cancel() {
      this.verificationForm.smgcode = ''
      this.authorizeData.messageId = ''
      this.dialogVisible = false
      this.auth_time = 0
      this.sendAuthCode = true
    }
  }
}
</script>
<style>
  .verification-Form input, .verification-Form button{
    height: 48px;
  }
</style>
<style scoped>
  .verification-tip{
    font-size: 14px;
    color: #D75B57;
    width: 400px;
    margin: 0 auto 28px;
  }

  .code-btn{
    position: absolute;
    right: 0;
    top: 0;
  }

  .verification-phone{
    font-size: 14px;
    color: #333333;
    width: 400px;
    margin: 0 auto 28px;
  }

  .verification-Form{
    width: 400px;
    margin: 0 auto;
  }

  .dialog-btns{
    width: 400px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
  }

  .dialog-btns button {
    display: block;
    width: 179px;
    height: 50px;
    font-size: 18px;
    border-radius: 10px;
  }
</style>